import { render, staticRenderFns } from "./medicalRecords.vue?vue&type=template&id=38351004"
import script from "./medicalRecords.vue?vue&type=script&lang=js"
export * from "./medicalRecords.vue?vue&type=script&lang=js"
import style0 from "./medicalRecords.vue?vue&type=style&index=0&id=38351004&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports